var _path, _text, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233,
    height: 55,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "#3D3D3D",
    d: "M3.5 3.5h226v48H3.5v-48z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 88.5,
    y: 30.437,
    fill: "#222",
    fontFamily: "Sabon LT Std",
    fontSize: 14,
    fontWeight: "bold"
  }, "\n        more\n    ")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M144.514 26.229l-3.285 3.286-.229-.229-.229.229-3.286-3.286.744-.743 2.771 2.77 2.77-2.77.744.743z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreBox);
export default __webpack_public_path__ + "static/media/more-box.deacbd87e9cfadd7e496912a7c14358d.svg";
export { ForwardRef as ReactComponent };